
<template>
<!-- footer-section start-->
<div class="footer-section">
  <div class="container py-4">
    <div class="row text-center text-md-start">
        <div class="col-12 col-md-6 mb-2 mb-md-0">
          <p class="mb-0 footer-links">
            <a :href="privacy_policy" class="mx-2 text-decoration-none text-white" >Privacy Policy</a> |
            <!-- <a href="https://visamedical.kimshealth.org/refund-policy" class="mx-2 text-decoration-none text-white">Refund Policy</a> | -->
            <a :href="terms_and_conditions" class="mx-2 text-decoration-none text-white">Terms & Conditions</a> |
            <a href="#" @click.prevent="handleTrackClick" class="mx-2 text-decoration-none text-white">Track Appointment(s)</a>
          </p>
        </div>
        <p class="col-12 col-md-6 text-md-end">
            Copyright © 2025, Designed & Developed by <a href="https://www.kenland.in/" class="mx-2 text-decoration-none text-white" >Kenland IT Solutions Pvt. Ltd.</a>
        </p>
    </div>
  </div>
</div>
<!-- footer-section end-->
</template>
<script>
import { LogoutPage } from '@/api/Post/action.js';
import Swal from 'sweetalert2';
 export default {
    data() {
        return {
            trackAppointment : '/trackAppointment',
            privacy_policy : '/privacy-policy',
            terms_and_conditions : '/terms-conditions',
        };
    },
    methods: {
      handleTrackClick() {
        LogoutPage()
          .then(() => {
            //console.log('logot success');
            localStorage.removeItem('authToken');
            this.$router.push({ name: 'trackAppointment' });
          })
          .catch((error) => {
            ///console.log('logot failed');
            this.$router.push({ name: 'trackAppointment' });
          });
      },
    }
 }
</script>